import { postApiGalaxyServer } from 'services';
import ApiClientManager from 'core/apiClient';
import { CreateDraftParams, CreateDraftResponse } from 'IntegrationModule/types';

export const createDraftIntegrationApi = ({
  params,
  token,
  config = {},
}: BaseApiParams<CreateDraftParams>) => {
  const customHeaders =
    params.tenant && params.realmId
      ? ApiClientManager.buildUrlHeaders({ tenantName: params.tenant, realmId: params.realmId })
      : undefined;

  const { tenant: _tenant, ...bodyParams } = params;

  return postApiGalaxyServer<Omit<CreateDraftParams, 'tenant'>, CreateDraftResponse>(
    `/integrations_api/draft`,
    bodyParams,
    { ...config, ...(customHeaders && { headers: customHeaders }) },
    token,
  );
};
